<div class="successful-registration-container">
  <h4 class="margin-header-align text-message-align">
    {{'app.successful-registration.message' | translate}}
  </h4>
</div>
